import { styled } from '@mui/material';
import { ReactComponent as IconDots } from '../../../assets/images/dots.svg';

export const StyledIconDots = styled(IconDots)(() => ({
  height: '13px',
  width: '15px',
  marginRight: '9px',
}));
